import { render, staticRenderFns } from "./Personalauthentication.vue?vue&type=template&id=093d340e&scoped=true"
import script from "./Personalauthentication.vue?vue&type=script&lang=js"
export * from "./Personalauthentication.vue?vue&type=script&lang=js"
import style0 from "./Personalauthentication.vue?vue&type=style&index=0&id=093d340e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d340e",
  null
  
)

export default component.exports